import axios from "axios"
import { ELECTRUM_API_URL } from "../consts"

export const getRentDates = async () => {
  const result = await axios.get(`${ELECTRUM_API_URL}/user-sepekan/dates`)
  return result.data
}
